// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createmodify-menu {
    position: fixed;
    background: #fff;
    color: #000;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0.5vw 0.3vw;
    z-index: 1000;
    cursor: pointer;
    height: auto;
    width: auto;
    min-width: 10vw;
    font-family: karla;
    font-weight: 500;
    font-size: 1vw;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    gap: 0.3vw;
}

.createmodify-menu-inner {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 0.8vw;
    gap: 0.5vw;
    border-radius: 4px;
    height: 4.4vh;
    min-height: 36px;
    width: 100%;
    box-sizing: border-box;
}

.createmodify-menu-inner:hover {
    background: #444444;
    color: #fff;
    border-color: #000;
}

.createmodify-menu-inner:hover svg {
    color: white !important;
    fill: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/CreateModal/createmodification.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB","sourcesContent":[".createmodify-menu {\n    position: fixed;\n    background: #fff;\n    color: #000;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 0.5vw 0.3vw;\n    z-index: 1000;\n    cursor: pointer;\n    height: auto;\n    width: auto;\n    min-width: 10vw;\n    font-family: karla;\n    font-weight: 500;\n    font-size: 1vw;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: center;\n    gap: 0.3vw;\n}\n\n.createmodify-menu-inner {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 0 0.8vw;\n    gap: 0.5vw;\n    border-radius: 4px;\n    height: 4.4vh;\n    min-height: 36px;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.createmodify-menu-inner:hover {\n    background: #444444;\n    color: #fff;\n    border-color: #000;\n}\n\n.createmodify-menu-inner:hover svg {\n    color: white !important;\n    fill: #fff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
